import { useDialog } from 'primevue/usedialog'
import { computed } from 'vue'
import { useCustomPageElementsActions } from './useCustomPageElementsActions'
import VideoEditDialog from '../components/cms/admin/video/videoEditDialog.vue'
import LinkEditDialog from '../components/cms/admin/link/linkEditDialog.vue'
import ImageEditDialog from '../components/cms/admin/image/imageEditDialog.vue'
import CustomComponentEditDialog from '../components/cms/admin/CustomComponent/customComponentEditDialog.vue'
import CustomComponentListEditDialog from '../components/cms/admin/CustomComponent/customComponentListEditDialog.vue'
import { useComponentListBlockContextMenuOptionsShowStatesStore, useCustomComponentContextMenuOptionsShowStatesStore, useCustomComponentListContextMenuOptionsShowStatesStore, useImageContextMenuOptionsShowStatesStore, useLinkContextMenuOptionsShowStatesStore, useVideoContextMenuOptionsShowStatesStore } from '#imports'

export const useContextMenus = () => {
  const dialog = useDialog()

  const VideoContextMenuOptionsShowStatesStore = useVideoContextMenuOptionsShowStatesStore()
  const LinkContextMenuOptionsShowStatesStore = useLinkContextMenuOptionsShowStatesStore()
  const CustomComponentContextMenuOptionsShowStatesStore = useCustomComponentContextMenuOptionsShowStatesStore()
  const CustomComponentListContextMenuOptionsShowStatesStore = useCustomComponentListContextMenuOptionsShowStatesStore()
  const ComponentListBlockContextMenuOptionsShowStatesStore = useComponentListBlockContextMenuOptionsShowStatesStore()

  const showVideoEditDialog = () => {
    dialog.open(VideoEditDialog, {
      props: {
        header: 'Edit video',
        style: {
          width: '80vw',
          height: '80vh'
        },
        modal: true
      },
      onClose: () => {

      }
    })
  }

  const cms_video_element_contextMenuItems = computed(() => {
    return VideoContextMenuOptionsShowStatesStore.czyPokazac()
      ? {
          label: 'Zmień video',
          command: () => {
            showVideoEditDialog()
          }
        }
      : null
  })

  const showLinkEditDialog = () => {
    dialog.open(LinkEditDialog, {
      props: {
        header: 'Edit link',
        modal: true
      },
      onClose: () => {

      }
    })
  }

  const cms_link_element_contextMenuItems = computed(() => {
    return LinkContextMenuOptionsShowStatesStore.czyPokazac()
      ? {
          label: 'Zmień link',
          command: () => {
            showLinkEditDialog()
          }
        }
      : null
  })

  const showImageEditDialog = () => {
    dialog.open(ImageEditDialog, {
      props: {
        header: 'Edit image',
        modal: true
      },
      onClose: () => {

      }
    })
  }

  const ImageContextMenuOptionsShowStatesStore = useImageContextMenuOptionsShowStatesStore()
  const cms_imege_element_contextMenuItems = computed(() => {
    return ImageContextMenuOptionsShowStatesStore.czyPokazac()
      ? {
          label: 'Edytuj obraz',
          command: () => {
            showImageEditDialog()
          }
        }
      : null
  })

  const showCustomComponentEditDialog = () => {
    dialog.open(CustomComponentEditDialog, {
      props: {
        header: 'Edit component',
        modal: true,
        style: {
          maxWidth: '80vw',
          maxHeight: '80vh'
        }
      },
      onClose: () => {

      }
    })
  }

  const cms_custom_component_contextMenuItems = computed(() => {
    return CustomComponentContextMenuOptionsShowStatesStore.czyPokazac()
      ? {
          label: 'Zmień custom component',
          command: () => {
            showCustomComponentEditDialog()
          }
        }
      : null
  })

  const { customPageOptionsGlobalMenu } = useCustomPageElementsActions()
  const cms_custom_list_block_contextMenuItems = computed(() => {
    return ComponentListBlockContextMenuOptionsShowStatesStore.czyPokazac() ? customPageOptionsGlobalMenu : null
  })

  const showCustomComponentListEditDialog = () => {
    dialog.open(CustomComponentListEditDialog, {
      props: {
        header: 'Edit components list',
        modal: true,
        style: {
          maxWidth: '80vw',
          maxHeight: '80vh'
        }
      },
      onClose: () => {

      }
    })
  }

  const cms_custom_component_list_contextMenuItems = computed(() => {
    return CustomComponentListContextMenuOptionsShowStatesStore.czyPokazac()
      ? {
          label: 'Zmień custom component list',
          command: () => {
            showCustomComponentListEditDialog()
          }
        }
      : null
  })

  return { cms_custom_list_block_contextMenuItems, cms_video_element_contextMenuItems, cms_link_element_contextMenuItems, cms_imege_element_contextMenuItems, cms_custom_component_contextMenuItems, cms_custom_component_list_contextMenuItems }
}
